export default "__VITE_ASSET__BlUXLKQ5__"